// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3JUhF","footer":"ReportModalFilter_footer__KVse8"};